import React from 'react';
import { useDialogStore } from './useDialogStore';
import { getLegacyDialogMapper } from './utils';

/**
 * Component to render dialogs from the dialog store.
 */
export const DialogStore = () => {
  const { dialogs } = useDialogStore();

  if (!dialogs.length) {
    return null;
  }

  return (
    <>
      {dialogs?.map(dialog => {
        if (!dialog?.component) {
          const Dialog = getLegacyDialogMapper(dialog.key);

          if (Dialog !== null) {
            return <Dialog key={dialog.key} />;
          }
        }

        return dialog.component;
      })}
    </>
  );
};
